'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var noflakeSchema = require('./noflakeSchema.js');
var useAnalyticsPost = require('./useAnalyticsPost.js');
var WebVitals = require('./WebVitals.js');



Object.defineProperty(exports, 'NoflakeTag', {
	enumerable: true,
	get: function () {
		return noflakeSchema.NoflakeTag;
	}
});
exports.AnalyticsContext = useAnalyticsPost.AnalyticsContext;
exports.AnalyticsProvider = useAnalyticsPost.AnalyticsProvider;
exports.COMPONENT_RENDER_QUEUE_INTERVAL = useAnalyticsPost.COMPONENT_RENDER_QUEUE_INTERVAL;
exports.DEFAULT_ANALYTICS_CONTEXT = useAnalyticsPost.DEFAULT_ANALYTICS_CONTEXT;
Object.defineProperty(exports, 'NarvarClickSubTypes', {
	enumerable: true,
	get: function () {
		return useAnalyticsPost.NarvarClickSubTypes;
	}
});
Object.defineProperty(exports, 'NarvarClickTypes', {
	enumerable: true,
	get: function () {
		return useAnalyticsPost.NarvarClickTypes;
	}
});
Object.defineProperty(exports, 'NarvarEventComponents', {
	enumerable: true,
	get: function () {
		return useAnalyticsPost.NarvarEventComponents;
	}
});
Object.defineProperty(exports, 'NarvarEventTypes', {
	enumerable: true,
	get: function () {
		return useAnalyticsPost.NarvarEventTypes;
	}
});
exports.QUEUE_INTERVAL = useAnalyticsPost.QUEUE_INTERVAL;
exports.flushAnalyticsQueue = useAnalyticsPost.flushAnalyticsQueue;
exports.setDequeInterval = useAnalyticsPost.setDequeInterval;
exports.setEnqueueComponentRenderInterval = useAnalyticsPost.setEnqueueComponentRenderInterval;
exports.useAnalyticsContext = useAnalyticsPost.useAnalyticsContext;
exports.useAnalyticsPost = useAnalyticsPost.useAnalyticsPost;
exports.WebVitals = WebVitals.WebVitals;
